var map = {
	"./author-page.png": 526,
	"./chat-app.png": 84,
	"./converter.png": 879,
	"./country-list.png": 244,
	"./event-calendar.png": 960,
	"./fashion-house.png": 291,
	"./food-next-app.png": 206,
	"./happy-hostel.png": 470,
	"./huddle.png": 828,
	"./markdown-notes.png": 724,
	"./plant-shop.png": 369,
	"./quiz.png": 294,
	"./shortly.png": 700,
	"./space-travel.png": 367,
	"./weather-app.png": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;